import { useQuery } from "@apollo/client/react";
import { PROJECT_INTEGRATION_RECORDS_QUERY } from "src/constants/graphql/queries";

export default function useProjectMovewareLink(projectId) {
  const { data } = useQuery(PROJECT_INTEGRATION_RECORDS_QUERY, {
    variables: { id: projectId },
    skip: !projectId,
  });

  return Boolean(
    data?.project?.externalRecords?.find(record => record.recordType === "storage_account")
  );
}
